import React from 'react'
import EyeSlashIcon from '../assets/svgIcons/EyeSlashIcon'
import EyeIcon from '../assets/svgIcons/EyeIcon'

const ViewPassword = ({ showPassword, setShowPassword, error }) => {
    const togglePasswordVisibility = () => setShowPassword(!showPassword);
    if (error) return
    return (
        <button
            type="button"
            className="position-absolute translate-middle-y me-2 border-0 bg-transparent text-primary"
            style={{ right: 0, top: !showPassword ? '62%' : '65%' }}
            onClick={togglePasswordVisibility}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
        >
            {showPassword ? (
                <EyeSlashIcon size={18} />
            ) : (
                <EyeIcon size={17} />
            )}
        </button>
    )
}

export default ViewPassword